// extracted by mini-css-extract-plugin
module.exports = {"neu":"neumorphic_neu__ZfcsV","neu-inset":"neumorphic_neu-inset__QxBWx","neu-hover":"neumorphic_neu-hover__WJQ2B"};